import { Component, OnInit } from '@angular/core';
import {AuthenticationServiceService} from '../../../authentication/service/authentication-service.service';
import {Router} from '@angular/router';
import {FirmwareService} from '../../service/firmware.service';

@Component({
  selector: 'app-firmware-view',
  templateUrl: './firmware-view.component.html',
  styleUrls: ['./firmware-view.component.css']
})
export class FirmwareViewComponent implements OnInit {
  public firmwareDetails: any = [];
  public noOfFirmwares: any;
  public loading = true;
  itemsPerPage = 10;
  currentPage = 1;
  regExp = '';

  constructor(private firmwareService: FirmwareService, private router: Router) { }

  ngOnInit() {
    this.getAllFirmWares();
  }


  pageChanged(event) {
    this.currentPage = event;
    this.getAllFirmWares();
    console.log(event);
  }
  public getAllFirmWares() {
    this.loading = true;
    this.firmwareService.getAllFirmWares(this.currentPage - 1, this.itemsPerPage, this.regExp)
        .subscribe(data => {
          const response: any = data.json();
          this.firmwareDetails = response.firmwareDetails;
          this.noOfFirmwares = response.numberOfFirmwareDetails;
          console.log(response.firmwareDetails);

          this.loading = false;
          // TODO - Uncomment below code when useing actual API
          // const response: any = data;
          // if (response.status === 200) {
          //   this.userList = response.result;
          // } else {
          //   this.toastr.error('', 'Please try again');
          // }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

  search() {
    console.log('' + this.regExp);
    this.getAllFirmWares();
  }
}
